import React from 'react';
import cn from 'clsx';

import styles from './sticky-footer.scss';

interface StickyFooterProps {
  className?: string;
  isAlwaysSticky?: boolean;
}

function StickyFooter(props: React.PropsWithChildren<StickyFooterProps>) {
  const { children, className = '', isAlwaysSticky = false } = props;
  const containerClassName = isAlwaysSticky ? 'sticky-container' : 'container';

  return (
    <footer
      className={cn(styles[containerClassName], `sticky-footer ${className}`)}
    >
      {children}
    </footer>
  );
}

export default StickyFooter;
